module.exports = __webpack_public_path__ + "static/media/IMG_3489_sm.1b9ef623.jpg";